import React from 'react';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { dropBoolean } from 'utils/drops';
import Card from 'components/Card';
import Input from 'components/Input';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import InputMask from 'components/InputMask';
import VirtualDrop from 'components/VirtualDrop';
import styles from '../styles';

const Indicadores = ({
  drops,
  loading,
  onSubmit,
  documento = {},
  disableActions,
}) => {
  const defaultValues = {
    documento_id: documento?.id,
    tipo_id: documento?.DocumentoIndicadore?.tipo_id || null,
    indicacao_id: documento?.DocumentoIndicadore?.indicacao_id || null,
    atividadefim_id: documento?.DocumentoIndicadore?.atividadefim_id || null,
    regiao_id: documento?.DocumentoIndicadore?.regiao_id || null,
    negocio_id: documento?.DocumentoIndicadore?.negocio_id || null,
    inspecionar: documento?.DocumentoIndicadore?.inspecionar || null,
    certificado: documento?.DocumentoIndicadore?.certificado || null,
    munch: documento?.DocumentoIndicadore?.munch || null,
    seguradora: documento?.DocumentoIndicadore?.seguradora || '',
    taxaseguro: documento?.DocumentoIndicadore?.taxaseguro || '',
    cliente_final: documento?.DocumentoIndicadore?.cliente_final || null,
  };
  const { control, handleSubmit } = useForm({ defaultValues });

  return (
    <Card title="Indicadores" style={styles?.card}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="tipo_id"
            control={control}
            label="Tipo"
            options={drops?.IndicadoresTipo}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="indicacao_id"
            control={control}
            label="Indicação"
            options={drops?.IndicadoresIndicacao}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="atividadefim_id"
            control={control}
            label="Atividade Final"
            options={drops?.IndicadoresAtividade}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            name="regiao_id"
            control={control}
            label="Região"
            options={drops?.IndicadoresRegiao}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            name="negocio_id"
            control={control}
            label="Negócio"
            options={drops?.IndicadoresNegocio}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="inspecionar"
            control={control}
            label="Inspecionar"
            options={dropBoolean}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="certificado"
            control={control}
            label="Certificado"
            options={dropBoolean}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="munch"
            control={control}
            label="Munch"
            options={dropBoolean}
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Input name="seguradora" control={control} label="Seguradora" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            name="taxaseguro"
            control={control}
            label="Taxa do Seguro"
          />
        </Grid>
        <Grid item xs={12}>
          <VirtualDrop
            name="cliente_final"
            control={control}
            label="Cliente Final"
            options={drops?.Entidade}
          />
        </Grid>
        {!disableActions && (
          <Grid item xs={12} textAlign="center">
            <Button
              color="primary"
              variant="outlined"
              loading={loading}
              onClick={handleSubmit((Indicador) => onSubmit({ Indicador }))}
            >
              Salvar
            </Button>
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default Indicadores;
